import clsx from "clsx";
import React from "react";
import {useTranslation} from "react-i18next";

const PackageCreditInfoPillow = (props: {color: string; title: string; subtitle: string}) => {
    const {t} = useTranslation();

    const colorClass = props.color == "red" ? "bg-arbo-red/5" : "bg-brand-yellow/5";
    return (
        <div className={clsx("PackageCreditInfoPillow text-xs flex-0 flex lg:flex-col items-center gap-1 w-auto font-medium p-1 rounded", colorClass)}>
            <div className={"text-left whitespace-break-spaces"}>
                <span className={"font-semibold"}>{props.title}</span>
                {"  "}
                <span dangerouslySetInnerHTML={{__html: props.subtitle}} />
            </div>
        </div>
    );
};

export default PackageCreditInfoPillow;
